// Core
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { restAPIs } from 'utils/restAPIs';
import { fetchData } from 'utils/fetch';
import InputField from 'components/commonComponents/InputField';
import Button from 'components/commonComponents/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useAlert } from 'hooks/useAlert';
import AlertSnackbar from 'components/commonComponents/AlertSnackbar';
import ActionLink from 'components/commonComponents/ActionLink';

// Styles
import './styles.scss';


const ResetPassword = (props) => {
  const { onClose, open, email, otp } = props;
  const { t } = useTranslation();
  const [passwordSet, setPasswords] = useState({});
  const [errorPswd, setErrorPswd] = useState({});
  const [isLoadingPswd, setIsLoadingPswd] = useState(false);
  const { newPassword, confirmPassword } = passwordSet;
  const { errorAlert, setErrorAlert, showAlert } = useAlert();

  const handleOnChangePassword = (key) => (_value) => {
    if (_value) {
      setErrorPswd({
        ...errorPswd,
        [key]: null
      });
    }
    setPasswords({
      ...passwordSet,
      [key]: _value
    });
  };


  const handlePasswordSave = async () => {
    const errors = {
      newPassword: !newPassword,
      confirmPassword: !confirmPassword
    };

    setErrorPswd(errors);
    let isFormValid = Object.values(errors).every((item) => !item);
    if (newPassword !== confirmPassword) {
      setErrorPswd((prev) => ({ ...prev, confirmPassword: 'Passwords must be same' }));
      isFormValid = false;
    }
    if (!isFormValid) return;
    setIsLoadingPswd(true);
    const formData = new FormData();
    formData.append('email', email)
    formData.append('otp', otp)
    formData.append('newPassword', btoa(unescape(encodeURIComponent(newPassword))))
    formData.append('appId', '29')

    const res = await fetchData(restAPIs.resetPassword(formData));
    if (res.statusCode === 200) {
      setPasswords({});
      setErrorPswd({});
      showAlert(res.errormessage, 'success');
      handleClose();
    } else {
      showAlert(res.errormessage, 'error');
    }
    setIsLoadingPswd(false);
  };

  const handleClose = (event, reason) => {
    setPasswords({});
    setErrorPswd({});
    setErrorAlert({})
    if (reason === "backdropClick") {
      console.log(reason);
    } else {
      onClose();
    }
  };


  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        className='__common_model_class'
        maxWidth={'sm'}
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">
        {t('change_password')}
        </DialogTitle>
        <DialogContent>
          <div className='mt-2'>
            <InputField
              onChange={handleOnChangePassword('newPassword')}
              value={newPassword}
              placeholder={t('password')}
              type='text'
              label={t('new_password')}
              error={errorPswd.newPassword}
            />
          </div>
          <div className='mt-4'>
            <InputField
              onChange={handleOnChangePassword('confirmPassword')}
              value={confirmPassword}
              placeholder={t('password')}
              type='text'
              label={t('confirm_password')}
              error={errorPswd.confirmPassword}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <div className='d-flex align-items-center' style={{ margin: '15px' }}>
            <ActionLink onClick={() => handleClose(false)} style={{ cursor: 'pointer', margin: '0 10px' }}>{t('cancel')}</ActionLink>
            <Button
              withLoader
              loading={isLoadingPswd}
              disabled={isLoadingPswd}
              handleOnClick={handlePasswordSave}
              label={t('submit')}
            />
          </div>
        </DialogActions>
        <AlertSnackbar alert={errorAlert} />
      </Dialog>
    </>
  );
};

export default ResetPassword;

ResetPassword.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  email: PropTypes.any,
  otp: PropTypes.any,
};
